(() => {
  if (customElements.get('hho-litter-subscription')) return;
  class LitterSubscription extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.scope = this.closest('.product-section') || this.form;
      this.variants = JSON.parse(this.querySelector('[data-hls-data]').textContent);
      this.once = this.querySelector('[data-hls-once]');
      this.subscribe = this.querySelector('[data-hls-subscribe]');
      this.frequency = this.querySelector('[data-hls-frequency]');
      this.planInput = this.querySelector('[data-hls-plan]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.changeVariant = event => {
        const id = event.detail?.variant?.id || this.form.querySelector('[name="id"]')?.value;
        this.syncVariant(id);
      };
      this.changeForm = event => {
        if (event.target.name === 'id') this.changeVariant(event);
      };
      this.guardSubmit = event => {
        if (this.subscribe.checked && !this.selectedPlan()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[data-hls-pending]').hidden = false;
        }
      };
      this.scope.addEventListener('variantChange', this.changeVariant);
      this.form.addEventListener('change', this.changeForm);
      this.form.addEventListener('submit', this.guardSubmit, true);
      this.addEventListener('change', () => this.syncSelection());
      this.syncVariant(this.form.querySelector('[name="id"]')?.value);
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('variantChange', this.changeVariant);
      this.form?.removeEventListener('change', this.changeForm);
      this.form?.removeEventListener('submit', this.guardSubmit, true);
      this.ready = false;
    }
    syncVariant(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) {
        this.planInput.disabled = true;
        this.planInput.value = '';
        this.subscribe.disabled = true;
        return;
      }
      if (this.variant?.id === variant.id) return;
      this.variant = variant;
      const plans = variant.plans.filter(p => p.recurring);
      this.frequency.replaceChildren();
      for (const plan of plans) this.frequency.add(new Option(plan.name.match(/\b(\d+\s*weeks?)\b/i)?.[1] || plan.name, String(plan.id)));
      const fourBags = /4\s*bags/i.test(variant.title);
      if (!plans.length) {
        for (const weeks of fourBags ? [4,8,12] : [2,4,6]) this.frequency.add(new Option(`${weeks} weeks`, ''));
        this.frequency.selectedIndex = 1;
        this.once.checked = true;
      } else {
        const preferred = plans.find(p => new RegExp(`\\b${fourBags ? 8 : 4}\\s*weeks?\\b`, 'i').test(p.name));
        if (preferred) this.frequency.value = String(preferred.id);
      }
      this.subscribe.disabled = !plans.length;
      this.querySelector('[data-hls-pending]').hidden = plans.length > 0;
      this.querySelector('[data-hls-once-price]').textContent = this.money.format(variant.price / 100);
      const originalPrice = this.querySelector('[data-hls-original-price]');
      if (originalPrice) originalPrice.textContent = this.money.format(variant.price / 100);
      this.syncSelection();
    }
    selectedPlan() {
      return this.variant?.plans.find(p => p.recurring && String(p.id) === this.frequency.value);
    }
    syncSelection() {
      if (!this.variant) return;
      const plan = this.selectedPlan();
      const subscribing = this.subscribe.checked && !!plan;
      this.planInput.disabled = !subscribing;
      this.planInput.value = subscribing ? String(plan.id) : '';
      this.frequency.disabled = !subscribing;
      this.dataset.subscribing = String(subscribing);
      this.querySelector('[data-hls-price]').textContent = this.money.format((plan?.price ?? Math.round(this.variant.price * .9)) / 100);
      this.querySelector('[data-hls-summary]').textContent = plan
        ? `${this.money.format(plan.price / 100)} per delivery · ${this.variant.title}`
        : 'Planned savings: 10% on every delivery. Not available to order yet.';
    }
  }
  customElements.define('hho-litter-subscription', LitterSubscription);
})();
